module.exports = __webpack_public_path__ + "static/js/refresh.cc854db2.chunk.worker.js"